var map = {
	"./Withdraw.svg": "jCUJ",
	"./cashflow.svg": "Vil5",
	"./home.svg": "U9Ws",
	"./info.svg": "Yfis",
	"./operationRcord.svg": "u0aY",
	"./payment.svg": "GDkK",
	"./recharge.svg": "OWYW",
	"./test.svg": "fjDP",
	"./virtual.svg": "obzq",
	"./withdrawal.svg": "+4WA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 19